import React from 'react';

function SFooter() {
  return (
		<footer className="section-gap">
			<div className="container">
				<div className="row pt-60">
				</div>
				<div className="footer-bottom d-flex justify-content-between align-items-center flex-wrap">
					<p className="footer-text m-0">Copyright &copy;<script>document.write(new Date().getFullYear());</script> All rights reserved | GOOD$</p>
				</div>
			</div>
		</footer>
  );
}

export default SFooter;
